import { render, staticRenderFns } from "./ExtraInsuranceApply.vue?vue&type=template&id=fde1d46e&scoped=true"
import script from "./ExtraInsuranceApply.vue?vue&type=script&lang=js"
export * from "./ExtraInsuranceApply.vue?vue&type=script&lang=js"
import style0 from "./ExtraInsuranceApply.vue?vue&type=style&index=0&id=fde1d46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde1d46e",
  null
  
)

export default component.exports